<h1 class="container-heading">Http logs</h1>
<mat-card>
    <mat-card-content>

        <common-table2 *ngIf="listTable" [settings]="listTable">
        </common-table2>

    </mat-card-content>
</mat-card>
